import {
  selectIsLandingProductFetchDisabled,
  selectIsSubscriptionEnabled,
} from 'src/common/selectors/config';
import connectAsync from '../../utils/connectAsync';
import { getCarouselItemsIfNeeded } from '../../actions/heroCarousel';
import fetchProducts from '../../utils/connectors/fetchProducts';
import LandingLoader from './LandingLoader';

// exported for testing purposes
export function fetchProductsIfNeeded({ store, location }) {
  const state = store.getState();
  if (
    selectIsSubscriptionEnabled(state) &&
    !selectIsLandingProductFetchDisabled(state)
  ) {
    return fetchProducts(location);
  }
  return null;
}

export default connectAsync([getCarouselItemsIfNeeded, fetchProductsIfNeeded])(
  LandingLoader,
);
